import { c as _c } from "react/compiler-runtime";
import { controlSurfaceAffixClassName, controlSurfaceAffixIconClassName, controlSurfaceFrameVariants, controlSurfaceInputClassName, controlSurfaceVariants } from "@/components/ui/control-surface";
import * as React from "react";
import cn from "twsx";
type InputProps = Omit<React.ComponentProps<"input">, "size"> & {
  prefix?: string | null;
  suffix?: string | null;
  prefixIcon?: React.ReactNode;
  suffixIcon?: React.ReactNode;
  size?: "sm" | "md";
  variant?: "default" | "bare";
  mono?: boolean;
  ref?: React.Ref<HTMLInputElement>;
};

/** Use when a person types a single line of text, a number or a search query. */
const Input = t0 => {
  const $ = _c(45);
  let className;
  let mono;
  let placeholder;
  let prefix;
  let prefixIcon;
  let props;
  let ref;
  let suffix;
  let suffixIcon;
  let t1;
  let type;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      type,
      prefix,
      suffix,
      prefixIcon,
      suffixIcon,
      size: t1,
      variant,
      mono,
      placeholder,
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = mono;
    $[3] = placeholder;
    $[4] = prefix;
    $[5] = prefixIcon;
    $[6] = props;
    $[7] = ref;
    $[8] = suffix;
    $[9] = suffixIcon;
    $[10] = t1;
    $[11] = type;
    $[12] = variant;
  } else {
    className = $[1];
    mono = $[2];
    placeholder = $[3];
    prefix = $[4];
    prefixIcon = $[5];
    props = $[6];
    ref = $[7];
    suffix = $[8];
    suffixIcon = $[9];
    t1 = $[10];
    type = $[11];
    variant = $[12];
  }
  const size = t1 === undefined ? "md" : t1;
  if (!prefix && !suffix && !prefixIcon && !suffixIcon) {
    let t2;
    if ($[13] !== className || $[14] !== mono || $[15] !== size || $[16] !== variant) {
      t2 = cn(controlSurfaceVariants({
        size,
        variant,
        mono
      }), className);
      $[13] = className;
      $[14] = mono;
      $[15] = size;
      $[16] = variant;
      $[17] = t2;
    } else {
      t2 = $[17];
    }
    let t3;
    if ($[18] !== placeholder || $[19] !== props || $[20] !== ref || $[21] !== t2 || $[22] !== type) {
      t3 = <input type={type} className={t2} ref={ref} placeholder={placeholder} {...props} />;
      $[18] = placeholder;
      $[19] = props;
      $[20] = ref;
      $[21] = t2;
      $[22] = type;
      $[23] = t3;
    } else {
      t3 = $[23];
    }
    return t3;
  }
  let t2;
  if ($[24] !== className || $[25] !== mono || $[26] !== size) {
    t2 = cn(controlSurfaceFrameVariants({
      size
    }), mono && "font-mono", className);
    $[24] = className;
    $[25] = mono;
    $[26] = size;
    $[27] = t2;
  } else {
    t2 = $[27];
  }
  const t3 = props.disabled ? "true" : undefined;
  let t4;
  if ($[28] !== prefix || $[29] !== prefixIcon) {
    t4 = (prefix || prefixIcon) && <div className={controlSurfaceAffixClassName}>{prefixIcon && <div className={controlSurfaceAffixIconClassName}>{prefixIcon}</div>}{prefix && <span>{prefix}</span>}</div>;
    $[28] = prefix;
    $[29] = prefixIcon;
    $[30] = t4;
  } else {
    t4 = $[30];
  }
  let t5;
  if ($[31] !== placeholder || $[32] !== props || $[33] !== ref || $[34] !== type) {
    t5 = <input type={type} className={controlSurfaceInputClassName} ref={ref} placeholder={placeholder} {...props} />;
    $[31] = placeholder;
    $[32] = props;
    $[33] = ref;
    $[34] = type;
    $[35] = t5;
  } else {
    t5 = $[35];
  }
  let t6;
  if ($[36] !== suffix || $[37] !== suffixIcon) {
    t6 = (suffix || suffixIcon) && <div className={controlSurfaceAffixClassName}>{suffix && <span>{suffix}</span>}{suffixIcon && <div className={controlSurfaceAffixIconClassName}>{suffixIcon}</div>}</div>;
    $[36] = suffix;
    $[37] = suffixIcon;
    $[38] = t6;
  } else {
    t6 = $[38];
  }
  let t7;
  if ($[39] !== t2 || $[40] !== t3 || $[41] !== t4 || $[42] !== t5 || $[43] !== t6) {
    t7 = <div className={t2} data-disabled={t3}>{t4}{t5}{t6}</div>;
    $[39] = t2;
    $[40] = t3;
    $[41] = t4;
    $[42] = t5;
    $[43] = t6;
    $[44] = t7;
  } else {
    t7 = $[44];
  }
  return t7;
};
Input.displayName = "Input";
export { Input };